// extracted by mini-css-extract-plugin
export default {"arrow_subtitle":"ArrowSubtitle_arrow_subtitle__SkR91","text":"ArrowSubtitle_text__LtG2I","dark":"ArrowSubtitle_dark__gAde-","arrow_image":"ArrowSubtitle_arrow_image__WGBQU"};